import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

function loadLocaleMessages() {
  let locale = localStorage.getItem("Lang");

  if (!locale) {
    localStorage.setItem("Lang", "LA");
  }

  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const appLang =
  localStorage.getItem("Lang") || process.env.VUE_APP_I18N_LOCALE || "LA";

// <html lang> drives the per-language font rule in public/scss/main.scss (TH gets a Thai
// face; BoonBaan draws Thai code points in a Lao style). Navbar.switchLanguage reloads the
// page, so setting it once at bootstrap is enough. App codes are not BCP 47: LA is Lao ("lo").
const HTML_LANG_BY_APP_LANG = { LA: "lo", CN: "zh", TH: "th", EN: "en" };
if (typeof document !== "undefined") {
  document.documentElement.setAttribute(
    "lang",
    HTML_LANG_BY_APP_LANG[appLang] || appLang.toLowerCase()
  );
}

export default new VueI18n({
  locale: appLang,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "CN",
  messages: loadLocaleMessages(),
});
